__webpack_require__.p = "/generated-html/vineyard-partners/";